import React from 'react';
import { SubHeading, MenuItem } from '../../components';
import { images, data } from '../../constants';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';


const SpecialMenu = () => (
  <div className='app__specialMenu flex__center section__padding' id='menu' >
    <div className='app__specialMenu-title' >
      <SubHeading title='Menu that fits your palette' />
      <h1 className='headtext__cormorant' >Today's Special</h1>
    </div>
    <div className='app__specialMenu-menu' >
      <div className='app__specialMenu-menu_course flex__center' >
        <p className='app__specialMenu-menu_heading' >Courses</p>
        <div className='app__specialMenu-menu_items' >
          {data.courses.map((course, index) => {
            return <MenuItem key={course.title + index} title={course.title} price={course.price} tags={course.tags} />
          })}
        </div>
      </div>
      <div className='app__specialMenu-menu_img flex__center' >
        <LazyLoadImage effect='blur' src={images.menu} alt='menu' />
      </div>
      <div className='app__specialMenu-menu_cocktails flex__center' >
        <p className='app__specialMenu-menu_heading' >Cocktails</p>
        <div className='app__specialMenu-menu_items' >
          {data.cocktails.map((cocktail, index) => {
            return <MenuItem key={cocktail.title + index} title={cocktail.title} price={cocktail.price} tags={cocktail.tags} />
          })}
        </div>
      </div>
    </div>
    <div className='app__specialMenu-menu_button' >
      <button type='button' className='custom__button' >View More</button>
    </div>
  </div>
);

export default SpecialMenu;
